import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import PrimeVue from 'primevue/config';

import { config } from '@/config';

import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faSearch, 
  faEnvelope, 
  faLock, 
  faEye, 
  faEyeSlash,
  faExclamationCircle,
  faHome,
  faBox,
  faUsers,
  faCreditCard,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faPlus,
  faEdit,
  faTrash,
  faTimes,
  faSave,
  faBan,
  faCheckCircle,
  faKey,
  faArrowLeft,
  faShoppingCart,
  faTag,
  faTimesCircle,
  faPhone,
  faMapMarkerAlt,
  faHeart,
  faFemale,
  faMale,
  faChild,
  faHome as faHomeIcon,
  faLaptop,
  faGamepad,
  faPuzzlePiece,
  faBicycle,
  faShirt,
  faShoePrints,
  faBagShopping,
  faGem,
  faSpa,
  faUtensils,
  faMobileAlt,
  faBook,
  faDumbbell,
  faFolderOpen,
  faPencilAlt,
  faUserPlus,
  faUser,
  faShoppingBag,
  faSignInAlt,
  // AVIS
  faStar,
  faSmile,
  faMeh,
  faFrown,
  // PAGES LÉGALES
  faShieldAlt,
  faUserShield,
  faTools,
  faHeadset,
  faInfoCircle,
  faUndoAlt,
  faTruck,
  faBoxOpen,
  faClipboardList,
  faClock,
  faShippingFast,
  faPlusCircle,
  faGavel,
  faBook as faBookSolid,
  faUpload,
  faCoins,
  faPercent,
  faLightbulb,
  faBalanceScale,
  faUserSecret,
  faGlobe,
  faSlidersH,
  faDatabase,
  faChartLine,
  faComments,
  faBullseye,
  faRocket,
  faMagic,
  faHandshake,
  faShareAlt,
  faCogs,
  faExclamationTriangle,
  faBell,
  faDownload,
  faTrashAlt,
  faCookieBite,
  faMoneyBillWave,
  faHandHoldingUsd,
  faReceipt,
  faFileInvoice,
  faFileContract,
  faHandshakeAlt,
  faStore,
  faClipboardCheck,
  faUserCheck,
  faUserTimes,
  faPhoneAlt,
  faMapPin,
  faLocationArrow,
  faCompass,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faThumbsUp,
  faThumbsDown,
  faMoneyCheck,
  // NOUVELLES ICÔNES POUR ADMIN TRANSACTIONS
  faExchangeAlt,
  faFileCsv,
  faMapMarkedAlt,
  faCity,
  faMoneyBill,
  faQuestionCircle,
  faSpinner,
  faFolder,
  faUserCog,
  faEnvelopeOpenText,
  faPaperPlane,
  faHeading,
  faAlignLeft,
  faFire,
  // ✅ NOUVELLES ICÔNES POUR LA CASE À COCHER CGU
  faCheckSquare,
  faSquare,
  faSimCard,
} from '@fortawesome/free-solid-svg-icons'

import { 
  faFacebookF,
  faInstagram,
  faTwitter,
  faTiktok,
  faWhatsapp as faWhatsappBrand
} from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  // Recherche et navigation
  faSearch, faEnvelope, faLock, faEye, faEyeSlash,
  faExclamationCircle, faHome, faBox, faUsers, faCreditCard,
  faSignOutAlt, faChevronLeft, faChevronRight, faChevronDown,
  
  // Actions CRUD
  faPlus, faEdit, faTrash, faTimes, faSave, faBan, faCheckCircle,
  faKey, faArrowLeft, faShoppingCart, faTag, faTimesCircle,
  
  // Communication
  faPhone, faPhoneAlt, faMapMarkerAlt, faHeart, faEnvelopeOpenText,
  faPaperPlane, faComments,
  
  // Genres
  faFemale, faMale, faChild,
  
  // Icônes d'icônes
  faHomeIcon, faLaptop, faGamepad, faPuzzlePiece, faBicycle,
  faShirt, faShoePrints, faBagShopping, faGem, faSpa,
  faUtensils, faMobileAlt, faBook, faDumbbell, faFolderOpen,
  faPencilAlt, faUserPlus, faUser, faShoppingBag, faSignInAlt,faFire,
  
  // AVIS
  faStar, faSmile, faMeh, faFrown,
  
  // PAGES LÉGALES
  faShieldAlt, faUserShield, faTools, faHeadset, faMoneyCheck,
  faInfoCircle, faUndoAlt, faTruck, faBoxOpen, faClipboardList,
  faClock, faShippingFast, faPlusCircle, faGavel, faBookSolid,
  faUpload, faCoins, faPercent, faLightbulb, faBalanceScale,
  faUserSecret, faGlobe, faSlidersH, faDatabase, faChartLine,
  faBullseye, faRocket, faMagic, faHandshake, faShareAlt,
  faCogs, faExclamationTriangle, faBell, faDownload,
  faTrashAlt, faCookieBite, faMoneyBillWave, faHandHoldingUsd,
  faReceipt, faFileInvoice, faFileContract, faHandshakeAlt,
  faStore, faClipboardCheck, faUserCheck, faUserTimes,
  faMapPin, faLocationArrow, faCompass, faFilter,
  faSort, faSortUp, faSortDown, faThumbsUp, faThumbsDown,
  
  // ADMIN TRANSACTIONS
  faExchangeAlt, faFileCsv, faMapMarkedAlt, faCity,
  faMoneyBill, faQuestionCircle, faSpinner, faFolder,
  faUserCog,

  faHeading,
  faAlignLeft,
  faSlidersH,
  faMoneyBillWave,
  faClipboardCheck,
  faCity,
  faTag,
  faSave,
  faSpinner,
  faTimes,
  faEdit,
  faBox,
  
  // ✅ NOUVELLES ICÔNES CGU
  faCheckSquare,
  faSquare,
  faSimCard,
  
  // BRANDS
  faFacebookF as any, faInstagram as any, faTwitter as any, faTiktok as any,
  faWhatsappBrand as any
);

import axios from 'axios'

const API_BASE_URL = config.apiUrl;
axios.defaults.baseURL = API_BASE_URL;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('client_token') || localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.Accept = 'application/json';
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('client_token');
      localStorage.removeItem('admin_token');
      localStorage.removeItem('client_user');
      localStorage.removeItem('admin_user');
    }
    return Promise.reject(error);
  }
);

export { axios as $api, API_BASE_URL };

const app = createApp(App);

app.provide('$api', axios);
app.provide('API_BASE_URL', API_BASE_URL);

app.use(router);
app.use(PrimeVue);

app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');